/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ask_AiInputs */

const th_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถามผู้ช่วย AI`)
};

const en_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask AI assistant`)
};

const ja_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIアシスタントに聞く`)
};

const zh_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`询问 AI 助手`)
};

const es_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntar al asistente de IA`)
};

const pt_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar ao assistente de IA`)
};

const id_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanya asisten AI`)
};

const fr_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander à l’assistant IA`)
};

const tl_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanungin ang AI assistant`)
};

const vi_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hỏi trợ lý AI`)
};

const ko_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 어시스턴트에게 묻기`)
};

const de_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Assistenten fragen`)
};

const ru_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спросить ИИ-помощника`)
};

const tr_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapay zekâ asistanına sor`)
};

const it_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi all'assistente IA`)
};

const pl_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapytaj asystenta AI`)
};

const uk_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запитати ШІ-помічника`)
};

const hi_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एआई सहायक से पूछें`)
};

const ar_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسأل المساعد الذكي`)
};

const ms_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanya pembantu AI`)
};

const bn_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এআই সহায়ককে জিজ্ঞাসা করুন`)
};

const zh_tw2_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詢問 AI 助理`)
};

const zh_hk2_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詢問 AI 助理`)
};

const ur_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اے آئی معاون سے پوچھیں`)
};

const fa_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`از دستیار هوش مصنوعی بپرسید`)
};

const sw_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uliza msaidizi wa AI`)
};

const nl_ask_ai = /** @type {(inputs: Ask_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vraag het de AI-assistent`)
};

/**
* | output |
* | --- |
* | "Ask AI assistant" |
*
* @param {Ask_AiInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const ask_ai = /** @type {((inputs?: Ask_AiInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ask_AiInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_ask_ai(inputs)
	if (locale === "ja") return ja_ask_ai(inputs)
	if (locale === "zh") return zh_ask_ai(inputs)
	if (locale === "es") return es_ask_ai(inputs)
	if (locale === "pt") return pt_ask_ai(inputs)
	if (locale === "id") return id_ask_ai(inputs)
	if (locale === "fr") return fr_ask_ai(inputs)
	if (locale === "tl") return tl_ask_ai(inputs)
	if (locale === "vi") return vi_ask_ai(inputs)
	if (locale === "ko") return ko_ask_ai(inputs)
	if (locale === "de") return de_ask_ai(inputs)
	if (locale === "ru") return ru_ask_ai(inputs)
	if (locale === "tr") return tr_ask_ai(inputs)
	if (locale === "it") return it_ask_ai(inputs)
	if (locale === "pl") return pl_ask_ai(inputs)
	if (locale === "uk") return uk_ask_ai(inputs)
	if (locale === "hi") return hi_ask_ai(inputs)
	if (locale === "ar") return ar_ask_ai(inputs)
	if (locale === "ms") return ms_ask_ai(inputs)
	if (locale === "bn") return bn_ask_ai(inputs)
	if (locale === "zh-TW") return zh_tw2_ask_ai(inputs)
	if (locale === "zh-HK") return zh_hk2_ask_ai(inputs)
	if (locale === "ur") return ur_ask_ai(inputs)
	if (locale === "fa") return fa_ask_ai(inputs)
	if (locale === "sw") return sw_ask_ai(inputs)
	if (locale === "nl") return nl_ask_ai(inputs)
	return en_ask_ai(inputs)
});